{
 "Settings": "הגדרות",
 "Business": "עסק",
 "Team": "צוות",
 "Integrations": "חיבורים",
 "Billing": "חיוב ותשלום",
 "Account": "חשבון",
 "Google Calendar connected": "Google Calendar חובר",
 "Google Calendar connection failed": "החיבור ל-Google Calendar נכשל",
 "Outlook calendar connected": "יומן Outlook חובר",
 "Outlook calendar connection failed": "החיבור ליומן Outlook נכשל",
 "Settings saved": "ההגדרות נשמרו",
 "Business name": "שם העסק",
 "Time zone": "אזור זמן",
 "Address and contact details": "כתובת ופרטי קשר",
 "Shared by the agent when customers ask how to get there.": "הנציג הדיגיטלי ישתף את הפרטים כשלקוחות שואלים איך מגיעים.",
 "Minimum notice (minutes)": "התראה מינימלית (בדקות)",
 "Book up to (days ahead)": "אפשר לקבוע עד (ימים קדימה)",
 "Offer start times every (min)": "הצעת שעות התחלה כל (דקות)",
 "Closed dates": "ימים סגורים",
 "Save": "שמירה",
 "Team member added": "חבר/ת הצוות נוספ/ה",
 "Removed": "הוסר",
 "Remove": "הסרה",
 "Add a team member": "הוספת חבר/ת צוות",
 "Name": "שם",
 "Email": "אימייל",
 "Role": "תפקיד",
 "Agents work the inbox and bookings; admins also change settings.": "נציגים מטפלים בתיבת ההודעות ובתורים; מנהלים יכולים גם לשנות הגדרות.",
 "Owner": "בעלים",
 "Agent": "נציג/ה",
 "Admin": "מנהל/ת",
 "Add": "הוספה",
 "Webhook added": "הוובהוק נוסף",
 "Connected": "מחובר",
 "Pick which calendar each staff member uses under Services & staff.": "בחירת היומן של כל איש צוות נעשית בעמוד שירותים וצוות.",
 "Disconnected": "החיבור נותק",
 "Disconnect": "ניתוק",
 "Let the agent see real availability and add bookings straight to your calendar.": "מאפשר לנציג הדיגיטלי לראות זמינות אמיתית ולהוסיף תורים ישירות ליומן שלכם.",
 "Connect Google Calendar": "חיבור Google Calendar",
 "Google may show a \"Google hasn't verified this app\" notice while its review of RELAYZA is in progress. Choose Advanced, then Continue to RELAYZA. We only create, move and delete the events RELAYZA books.": "ייתכן ש-Google תציג הודעה שהאפליקציה עדיין לא אומתה (Google hasn't verified this app), כל עוד הבדיקה שלה ל-RELAYZA בתהליך. לחצו \"מתקדם\" (Advanced) ואז \"המשך אל RELAYZA\". אנחנו יוצרים, מזיזים ומוחקים רק את האירועים ש-RELAYZA קובעת.",
 "Google OAuth isn't configured on this deployment yet.": "Google OAuth עדיין לא הוגדר בהתקנה הזו.",
 "Reconnect needed": "נדרש חיבור מחדש",
 "Google stopped accepting this connection, usually because access was revoked in the Google account. Until it is reconnected the agent books against its own schedule only, so events added straight to the calendar no longer block slots.": "Google הפסיקה לקבל את החיבור הזה, בדרך כלל מפני שהגישה בוטלה בחשבון Google. עד לחיבור מחדש הנציג הדיגיטלי קובע תורים לפי הלוח שלו בלבד, ולכן אירועים שנוספו ישירות ליומן לא חוסמים יותר מועדים.",
 "Reconnect Google Calendar": "חיבור מחדש של Google Calendar",
 "Outlook / Microsoft 365": "יומן Outlook / Microsoft 365",
 "Connect Outlook / Microsoft 365": "חיבור יומן Outlook / Microsoft 365",
 "Reconnect Outlook calendar": "חיבור מחדש של יומן Outlook",
 "Microsoft stopped accepting this connection, usually because access was revoked or the password changed in the Microsoft account. Until it is reconnected the agent books against its own schedule only, so events added straight to the calendar no longer block slots.": "Microsoft הפסיקה לקבל את החיבור הזה, בדרך כלל מפני שהגישה בוטלה או שהסיסמה שונתה בחשבון Microsoft. עד לחיבור מחדש הנציג הדיגיטלי קובע תורים לפי הלוח שלו בלבד, ולכן אירועים שנוספו ישירות ליומן לא חוסמים יותר מועדים.",
 "Switching replaces this connection, and each staff member's calendar is picked again under Services & staff.": "המעבר מחליף את החיבור הזה, ואת היומן של כל איש צוות בוחרים מחדש בעמוד שירותים וצוות.",
 "Switch to {provider}": "מעבר ל{provider}",
 "Webhooks": "וובהוקים",
 "Send events (booking.created, conversation.handoff, contact.stage_changed…) to your CRM, Zapier or Make. Each request is signed with HMAC-SHA256 in the {code} header.": "שליחת אירועים (booking.created, conversation.handoff, contact.stage_changed…) ל-CRM שלכם, ל-Zapier או ל-Make. כל בקשה נחתמת ב-HMAC-SHA256 בכותרת {code}.",
 "URL": "כתובת URL",
 "Events": "אירועים",
 "* for all, or a comma-separated list": "* לכל האירועים, או רשימה מופרדת בפסיקים",
 "Add webhook": "הוספת וובהוק",
 "Signing secret (shown once):": "סוד חתימה (מוצג פעם אחת בלבד):",
 "Alerts saved": "ההתראות נשמרו",
 "Test alert sent": "התראת בדיקה נשלחה",
 "Team alerts": "התראות לצוות",
 "Tell the team the moment something needs them. WhatsApp alerts go out from your business number.": "עדכון הצוות ברגע שמשהו דורש את תשומת ליבו. התראות בוואטסאפ נשלחות ממספר העסק שלכם.",
 "A chat needs a person": "שיחה דורשת נציג",
 "A new booking": "תור חדש",
 "The agent hit an error": "הנציג הדיגיטלי נתקל בשגיאה",
 "Staff WhatsApp numbers": "מספרי וואטסאפ של הצוות",
 "One per line, with country code, e.g. 972501234567": "מספר אחד בכל שורה, עם קידומת מדינה, לדוגמה 972501234567",
 "Alert template": "תבנית התראה",
 "WhatsApp only delivers free text to a number that messaged you in the last 24h. For the rest, an approved utility template with {{1}} customer and {{2}} what happened.": "וואטסאפ מעביר טקסט חופשי רק למספר ששלח לכם הודעה ב-24 השעות האחרונות. לשאר המספרים יש להשתמש בתבנית שירות מאושרת עם {{1}} ללקוח ו-{{2}} למה שקרה.",
 "Emails": "כתובות אימייל",
 "One per line": "אחת בכל שורה",
 "Send a test alert": "שליחת התראת בדיקה",
 "Deposits (Grow)": "מקדמות (Grow)",
 "Take a deposit when a customer books, by card, Bit, Apple Pay or Google Pay, so no-shows drop. Set the amount per service under Services & staff. Unpaid holds are released after 30 minutes.": "גביית מקדמה כשלקוח קובע תור, בכרטיס אשראי, Bit, Apple Pay או Google Pay, כדי לצמצם אי-הגעות. את הסכום לכל שירות קובעים בעמוד שירותים וצוות. תורים שלא שולמו משתחררים אחרי 30 דקות.",
 "Test mode: payments go to Grow's sandbox.": "מצב בדיקה: התשלומים עוברים לסביבת הבדיקות של Grow.",
 "Grow disconnected": "Grow נותק",
 "Grow connected": "Grow חובר",
 "Grow userId": "userId של Grow",
 "From Grow when you open API access": "מתקבל מ-Grow כשפותחים גישת API",
 "Grow pageCode": "pageCode של Grow",
 "The payment page code Grow gives you for this integration": "קוד עמוד התשלום ש-Grow מספקת לחיבור הזה",
 "Connect Grow": "חיבור Grow",
 "Only the business owner can connect payments.": "רק בעלי העסק יכולים לחבר תשלומים.",
 "How do I get these?": "איך משיגים את זה?",
 "Sign in to your Grow business account. No account yet? Open one first: Grow is the company that actually collects the deposit.": "היכנסו לחשבון העסקי שלכם ב-Grow. אין עדיין חשבון? פתחו אחד קודם: Grow היא החברה שגובה בפועל את המקדמה.",
 "Ask Grow's support or integrations team to open API access (Light API) for your account, and ask for your userId and pageCode.": "פנו לצוות התמיכה או האינטגרציות של Grow, בקשו לפתוח גישת API (Light API) לחשבון שלכם, ובקשו את ה-userId ואת ה-pageCode.",
 "Ask them to turn on card, Bit, Apple Pay and Google Pay on that payment page.": "בקשו מהם להפעיל בעמוד התשלום הזה כרטיס אשראי, Bit, Apple Pay ו-Google Pay.",
 "Paste both codes here and press Connect Grow.": "הדביקו כאן את שני הקודים ולחצו חיבור Grow.",
 "Both codes come from Grow, not from Morning (Green Invoice). A key from Morning's developer tools won't work here.": "שני הקודים מגיעים מ-Grow, לא מ-Morning (חשבונית ירוקה). מפתח מהכלים למפתחים של Morning לא יעבוד כאן.",
 "This looks like an API key from another service, such as Morning, not a code from Grow.": "זה נראה כמו מפתח API של שירות אחר, למשל Morning, ולא קוד של Grow.",
 "This doesn't look like a Grow userId.": "זה לא נראה כמו userId של Grow.",
 "This doesn't look like a Grow pageCode.": "זה לא נראה כמו pageCode של Grow.",
 "CRM sync": "סנכרון CRM",
 "Every lead becomes a CRM record with its stage kept up to date, plus a timeline note for each booking, cancellation and handoff.": "כל ליד הופך לרשומה ב-CRM, עם שלב שמתעדכן כל הזמן והערה בציר הזמן לכל תור, ביטול והעברה לנציג.",
 "Sync error": "שגיאת סנכרון",
 "last sync {time}": "סנכרון אחרון {time}",
 "Disconnect HubSpot": "ניתוק HubSpot",
 "HubSpot connected": "HubSpot חובר",
 "Private app access token": "טוקן גישה של Private app",
 "HubSpot → Settings → Integrations → Private apps, with crm.objects.contacts read and write.": "ב-HubSpot: Settings → Integrations → Private apps, עם הרשאות קריאה וכתיבה ל-crm.objects.contacts.",
 "Connect HubSpot": "חיבור HubSpot",
 "Board: {board}": "לוח: {board}",
 "Disconnect Monday.com": "ניתוק Monday.com",
 "API token": "טוקן API",
 "Monday → your avatar → Developers → My access tokens": "ב-Monday: תמונת הפרופיל שלכם → Developers → My access tokens",
 "Board id": "מזהה לוח",
 "The number in the board's URL": "המספר שמופיע בכתובת ה-URL של הלוח",
 "Phone column": "עמודת טלפון",
 "Email column": "עמודת אימייל",
 "Stage column": "עמודת שלב",
 "Don't sync": "ללא סנכרון",
 "Column id; connect once to pick from a list": "מזהה העמודה; אחרי חיבור ראשון אפשר לבחור מרשימה",
 "Monday.com connected": "Monday.com חובר",
 "Update Monday.com": "עדכון Monday.com",
 "Connect Monday.com": "חיבור Monday.com",
 "No subscription": "אין מנוי",
 "Payment incomplete": "התשלום לא הושלם",
 "Trial": "תקופת ניסיון",
 "Active": "פעיל",
 "Payment failed, retrying": "התשלום נכשל, מנסים שוב",
 "Cancelled": "בוטל",
 "Unpaid": "לא שולם",
 "Paused": "מושהה",
 "Included by your provider": "כלול אצל הספק שלכם",
 "Subscription": "מנוי",
 "Ends on {date}.": "מסתיים ב-{date}.",
 "Renews on {date}.": "מתחדש ב-{date}.",
 "Your AI agent is paused until a subscription is active. Customers' messages go to your inbox.": "הנציג הדיגיטלי מושהה עד שיהיה מנוי פעיל. הודעות של לקוחות מגיעות לתיבת ההודעות שלכם.",
 "Manage billing and invoices": "ניהול חיוב וחשבוניות",
 "Only the business owner can change billing.": "רק בעלי העסק יכולים לשנות את פרטי החיוב.",
 "Choose a plan": "בחירת מסלול",
 "Online billing isn't set up on this platform yet. Your provider will invoice you directly.": "חיוב מקוון עדיין לא הוגדר בפלטפורמה הזו. הספק שלכם ישלח לכם חשבונית ישירות.",
 "Subscribe": "הרשמה למנוי",
 "Password changed; other devices were signed out": "הסיסמה שונתה; בוצעה התנתקות במכשירים האחרים",
 "Change password": "שינוי סיסמה",
 "Current password": "סיסמה נוכחית",
 "Use the temporary password you were given if you haven't changed it yet.": "אם עדיין לא שיניתם אותה, יש להזין את הסיסמה הזמנית שקיבלתם.",
 "New password": "סיסמה חדשה",
 "At least 8 characters.": "לפחות 8 תווים.",
 "Confirm new password": "אימות הסיסמה החדשה",
 "Passwords don't match.": "הסיסמאות אינן תואמות.",
 "Business created": "העסק נוצר",
 "All businesses": "כל העסקים",
 "Platform view: onboard clients and watch usage": "תצוגת פלטפורמה: הצטרפות לקוחות ומעקב אחר שימוש",
 "Channels": "ערוצים",
 "Conversations (30d)": "שיחות (30 יום)",
 "Bookings (30d)": "תורים (30 יום)",
 "Tokens (30d)": "טוקנים (30 יום)",
 "Exempt": "פטור",
 "Remove exemption": "ביטול פטור",
 "Make exempt": "מתן פטור",
 "Suspended": "מושעה",
 "Suspend": "השעיה",
 "Activate": "הפעלה",
 "Onboard a business": "הוספת עסק חדש",
 "Owner name": "שם הבעלים",
 "Owner email": "אימייל הבעלים",
 "Create": "יצירה",
 "Customer contact email": "אימייל ליצירת קשר ללקוחות",
 "Shared by the agent, and replies to emails it sends customers arrive here.": "הנציג הדיגיטלי משתף אותו, ותשובות למיילים שהוא שולח ללקוחות מגיעות לכאן.",
 "Closed on Israeli public holidays": "סגור בחגי ישראל",
 "Filled in automatically every year. Untick a holiday you open on.": "מתמלא אוטומטית בכל שנה. בטלו סימון של חג שבו אתם פתוחים.",
 "One per line, YYYY-MM-DD (vacations, one-off closures, holiday eves).": "תאריך אחד בכל שורה, בפורמט YYYY-MM-DD (חופשות, סגירות חד-פעמיות, ערבי חג).",
 "This isn't a Make webhook address. Copy it from the Custom webhook module: https://hook.….make.com/…": "זו לא כתובת webhook של Make. העתיקו אותה מהמודול Custom webhook. כתובת נכונה מתחילה ב-https://hook וכוללת את make.com בהמשך.",
 "Grow connected through Make": "Grow חובר דרך Make",
 "Make answered with a payment link": "Make החזיר קישור תשלום",
 "through Make": "דרך Make",
 "Run a test after any change to the scenario: it asks Make for a ₪1 payment link and shows it here. Don't pay it.": "הריצו בדיקה אחרי כל שינוי בתרחיש: היא מבקשת מ-Make קישור תשלום על ₪1 ומציגה אותו כאן. אין לשלם אותו.",
 "Run a test": "הרצת בדיקה",
 "The scenario works. Test link:": "התרחיש עובד. קישור הבדיקה:",
 "How Grow connects": "איך Grow מתחבר",
 "Grow API codes": "קודי API של Grow",
 "Through Make": "דרך Make",
 "Grow said to connect through Make instead? Choose Through Make above.": "Grow אמרו להתחבר דרך Make? בחרו למעלה דרך Make.",
 "How do I set up Make?": "איך מגדירים את Make?",
 "Open a free account at make.com and create a scenario. Its first module is Webhooks → Custom webhook; copy the address it gives you.": "פתחו חשבון חינמי ב-make.com וצרו תרחיש (scenario). המודול הראשון הוא Webhooks ← Custom webhook; העתיקו את הכתובת שהוא נותן.",
 "Add Grow's own app → Create Payment Link, and connect it with your business ID number and the code Grow texts to your phone.": "הוסיפו את האפליקציה של Grow ← Create Payment Link, וחברו אותה עם מספר העוסק או ח.פ. והקוד ש-Grow שולחים לטלפון.",
 "Fill it from the webhook: Full Name ← full_name, Phone ← phone, Title ← title, one product priced at sum, Notify URL ← notify_url, Success URL ← success_url, Custom Field 1 ← reference. Sending mode: none.": "מלאו מתוך ה-webhook: Full Name ← full_name, Phone ← phone, Title ← title, מוצר אחד במחיר sum, Notify URL ← notify_url, Success URL ← success_url, Custom Field 1 ← reference. Sending mode: none.",
 "End with Webhooks → Webhook response, body {\"url\": …, \"process_id\": …, \"process_token\": …} from Grow's answer, set the scenario to run immediately and turn it on.": "סיימו ב-Webhooks ← Webhook response עם הגוף {\"url\": …, \"process_id\": …, \"process_token\": …} מתוך התשובה של Grow, הגדירו שהתרחיש ירוץ מיד והפעילו אותו.",
 "Paste the webhook address here, press Connect Grow, then Run a test.": "הדביקו כאן את כתובת ה-webhook, לחצו חיבור Grow ואז הרצת בדיקה.",
 "The payment goes from the customer to Grow; Grow tells us directly that it was paid. Make only creates the link, which costs about 3 Make credits per link.": "התשלום עובר מהלקוח ישירות ל-Grow, ו-Grow מעדכנים אותנו ישירות שהוא שולם. Make רק יוצר את הקישור, בעלות של כ-3 קרדיטים של Make לקישור.",
 "Make webhook address": "כתובת ה-webhook של Make",
 "From the Custom webhook module at the start of your scenario": "מהמודול Custom webhook בתחילת התרחיש",
 "Invite pending": "ההזמנה ממתינה",
 "Resend invite": "שליחת ההזמנה מחדש",
 "Copy link": "העתקת הקישור",
 "{email} already had an account. We emailed them that they were added.": "ל-{email} כבר היה חשבון. שלחנו מייל שהם צורפו.",
 "Invite sent to {email}. The link to choose a password works for 7 days.": "ההזמנה נשלחה ל-{email}. הקישור לבחירת סיסמה בתוקף ל-7 ימים.",
 "{email} already had an account and can sign in with it. We couldn't email them.": "ל-{email} כבר יש חשבון והם יכולים להיכנס איתו. לא הצלחנו לשלוח להם מייל.",
 "We couldn't email {email}. Send them this link yourself; it lets them choose a password, works once and lasts 7 days:": "לא הצלחנו לשלוח מייל ל-{email}. שלחו להם את הקישור הזה בעצמכם; הוא מאפשר לבחור סיסמה, פועל פעם אחת ובתוקף ל-7 ימים:",
 "We email them a link to choose their own password.": "נשלח להם מייל עם קישור לבחירת סיסמה משלהם.",
 "Welcome to RELAYZA": "ברוכים הבאים ל-RELAYZA",
 "Choose a password, then sign in with your email address and it.": "בחרו סיסמה, ואז היכנסו עם כתובת המייל שלכם והסיסמה הזו.",
 "Your password is set. Sign in with your email address and the new password.": "הסיסמה נשמרה. היכנסו עם כתובת המייל שלכם והסיסמה החדשה.",
 "Common": "נפוצים",
 "All time zones": "כל אזורי הזמן"
}
